import {isPast} from 'date-fns';

import {isNotNilOrEmpty} from 'ramda-adjunct';

import {Nullish, parseDate} from 'shared/web';

export function isSourcingCebiaReportUrlExpired(validTo: string | Nullish): boolean {
  const expiry = isNotNilOrEmpty(validTo) ? parseDate(validTo) : null;
  return expiry !== null && isPast(expiry);
}
